import { Box } from "../../box";
import { forwardRef } from "react";
import { mergeProps, useId } from "../../shared";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultElement = "div";
export function InnerFieldset({
  as = DefaultElement,
  children,
  forwardedRef,
  id,
  label,
  ...rest
}) {
  const rootId = useId(id, "o-ui-fieldset");
  const labelId = `${rootId}-label`;
  return /*#__PURE__*/_jsxs(Box, { ...mergeProps(rest, {
      "aria-labelledby": labelId,
      as,
      className: "o-ui-fieldset",
      id: rootId,
      ref: forwardedRef,
      role: "group"
    }),
    children: [/*#__PURE__*/_jsx("span", {
      className: "o-ui-fieldset-label",
      id: labelId,
      children: label
    }), children]
  });
}
InnerFieldset.defaultElement = DefaultElement;
export const Fieldset = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerFieldset, { ...props,
  forwardedRef: ref
}));